export default __webpack_public_path__ + "static/media/bkg--home-2.a8f11a1b.jpg";